// extracted by mini-css-extract-plugin
module.exports = {"barChartWrapper":"barGraph_barChartWrapper__1mAq1","toLeft":"barGraph_toLeft__3sKXN","progress":"barGraph_progress__2ssrP","toRight":"barGraph_toRight__2Ttyv"};